<template>
  <div class="outer-navigation">
    <div class="banner">
      <nav class="desktop">
        <!-- <a
          class="nav-link"
          target="_blank"
          :class="{'nav-group': !!item.subnav}"
          :href="'javascript:;'"
          :key="index"
          @click="handleNavLinkClick">
          {{item.text}}
        </a> -->
        <a
          v-for="(item, itemIndex) in navItems"
          :key="itemIndex"
          class="nav-link"
          :class="{'nav-group': !!item.subnav}"
          :href="'javascript:;'"
          @click="item.subnav ? null : handleNavLinkClick(item)"
        >
          {{ item.text }}
          <template v-if="item.subnav">
            <svg-icon
              class="icon up"
              color="red"
              name="vectorup"
            />
            <svg-icon
              class="icon down"
              color="red"
              name="vectordown"
            />
            <div class="dropdown">
              <a
                v-for="(subItem, subItemIndex) in item.subnav"
                :key="subItemIndex"
                class="nav-link"
                @click="handleNavLinkClick(subItem)"
                v-text="subItem.text"
              />
            </div>
          </template>
        </a>
      </nav>
      <a
        class="banner-logo"
        :href="getCesUrl"
        target="_blank"
        rel="noreferrer noopenner"
      >
        <img
          class="banner-logo-desktop-pic"
          :src="require('@/assets/images/banner_desktop.png')"
          alt="ces-official-exhibitor"
        >
        <img
          class="banner-logo-mobile-pic"
          :src="require('@/assets/images/banner_mobile.png')"
          alt="ces-official-exhibitor"
        >
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SvgIcon from '@/components/SvgIcon/index.vue'
import { cesNavigationConfig } from '~js/constants'
export default {
  components: {
    SvgIcon
  },
  data () {
    return {
      isSubnavShow: false,
      navItems: [
        {
          text: 'Home',
          href: cesNavigationConfig.homePanoramaId
        },
        {
          text: 'Expo Hall',
          subnav: [
            {
              text: 'Award',
              href: cesNavigationConfig.awardPanoramaId
            },
            {
              text: 'Cybersecurity & Cloud Solution',
              href: cesNavigationConfig.cybersecurityPanoramaId
            },
            {
              text: 'Health Care & Wellness',
              href: cesNavigationConfig.healthCarePanoramaId
            },
            {
              text: 'Live',
              href: cesNavigationConfig.livePanoramaId
            },
            {
              text: 'Mobility Tech',
              href: cesNavigationConfig.mobilityPanoramaId
            },
            {
              text: 'Smart Living',
              href: cesNavigationConfig.smartLivingPanoramaId
            },
            {
              text: 'Tech for Good',
              href: cesNavigationConfig.techForGoodPanoramaId
            }
          ]
        },
        {
          text: 'Agenda',
          subnav: [
            {
              text: '1/11 10:30-11:30(GMT+8) Press Conference',
              href: cesNavigationConfig.agendaOne,
              isExternal: true
            },
            {
              text: "1/12 05:00-05:30(GMT+8) Int'l Press Conference(Media Only)",
              href: cesNavigationConfig.agendaTwo,
              isExternal: true
            },
            {
              text: '1/12 05:30-06:00(GMT+8) Press QA(Media Only)',
              href: cesNavigationConfig.agendaThree,
              isExternal: true
            },
            {
              text: '1/12 20:00-21:00(GMT+8) TTA Virtual Booth Grand Opening(pwd:bzPMyUZV226)',
              href: cesNavigationConfig.agendaFour,
              isExternal: true
            },
            {
              text: '1/13 16:30-19:45(GMT+8) TTA Product Launch @ EU Market (pwd:TTACES2021)',
              href: cesNavigationConfig.agendaFive,
              isExternal: true
            },
            {
              text: '1/13 08:30-09:00(GMT+8) TTA Spotlight 1',
              href: cesNavigationConfig.agendaSix,
              isExternal: true
            },
            {
              text: '1/14 00:30-01:00(GMT+8) TTA Spotlight 2',
              href: cesNavigationConfig.agendaSeven,
              isExternal: true
            },
            {
              text: '1/14 09:30-13:40(GMT+8) TTA Product Launch @ ASEAN Market (pwd:TTACES2021)',
              href: cesNavigationConfig.agendaEight,
              isExternal: true
            }
          ]
        },
        // {
        //   text: 'Sponsor',
        //   href: ''
        // },
        {
          text: 'Contact Us',
          href: cesNavigationConfig.contactUsUrl,
          isExternal: true
        }
      ]
    }
  },
  computed: {

    getCesUrl () {
      return cesNavigationConfig.cesUrl
    },
    ...mapGetters([
      'currentBuilding'
    ])
  },
  methods: {
    ...mapActions([
      'selectPanorama',
      'selectBuilding'
    ]),
    handleNavLinkClick (navItem) {
      if (!navItem.href) {
        return
      }
      if (navItem.isExternal) {
        window.open(navItem.href || navItem.subnav.href)
        return
      }
      if (this.currentBuilding.objectId !== cesNavigationConfig.buildingId) {
        this.selectBuilding({ buildingId: cesNavigationConfig.buildingId, panorama: navItem.href })
        return
      }
      this.selectPanorama(navItem.href)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

$nav-height = 35px
.outer-navigation {
  background-color: #262626
  user-select: none

  .nav-link {
    color: #fff
    text-align: center
    text-shadow: none
    font-weight: 700
    font-family:Helvetica
    font-size: 16px
    display: block
    padding: 8px 20px
    cursor: pointer
    @media (max-width: 1000px) {
      padding: 8px 10px
    }
  }

  .banner {
    position: relative
    height: 140px
    padding: 25px
    background-color: #262626
    text-align: right
    @media (max-width: 767px) {
      height: 80px
      text-align: center
      padding: 15px 0 18px 0
      .banner-logo {
        height: 44px
        display: block
      }
      .banner-logo-desktop-pic {
        display: none
      }
      .banner-logo-mobile-pic {
        height: 100%
      }
    }
    @media (max-width: 321px) {
     .banner-logo {
        height: 38px
        display: block
      }
    }
    @media (min-width: $response) {
      .banner-logo {
        height: 70px
        display: block
      }
      .banner-logo-desktop-pic {
        height: 100%
      }
      .banner-logo-mobile-pic {
        display: none
      }
    }
  }

  .desktop {
    left: 60px
    bottom: 5px
    position: absolute
    display: flex
    align-items: center
    @media (max-width: 767px) {
      display: none
    }
    .nav-group {
      cursor: pointer
      position: relative
      display: flex
      .icon.up {
        margin: 0 10px
        display: none
      }
      .icon.down {
        margin: 0 10px
        display: block
      }
      &:hover {
        .dropdown {
          display: block
        }
        .down {
          display: none
        }
        .up {
          display: block
        }
      }
    }
    .dropdown {
      display: none
      position: absolute
      width: 250px
      top: $nav-height
      left: -50px
      background-color: #262626
      z-index: 9
      .nav-link {
        font-size: 14px
        font-family: Helvetica
        font-weight: 400
        color: #fff
        &:hover {
          background-color: #414141
        }
      }
    }
  }
}
</style>
